"use strict";

import { useCallback } from 'react';
import { useFlixApiContext } from '../../FlixApiContext';
/** Setup intents are used to capture card details and set them up for future off-session payments */

export var useCardSetupIntent = function useCardSetupIntent() {
  var _useFlixApiContext = useFlixApiContext(),
      flixApi = _useFlixApiContext.flixApi;

  var fetchSetupIntent = useCallback(function () {
    return flixApi('get', 'subscription/stripe-intent');
  }, [flixApi]);
  return {
    fetchSetupIntent: fetchSetupIntent
  };
};